import { EThemesOG } from '@/constants/themeConfig';
import * as sterlingparker from './Well.styles.sterlingparker';
import * as junglebet from './Well.styles.junglebet';
import * as volcanobet from './Well.styles.volcanobet';
import * as betprofessor from './Well.styles.betprofessor';
import * as puntgenie from './Well.styles.puntgenie';
import * as fiestabet from './Well.styles.fiestabet';
import * as puntcity from './Well.styles.puntcity';
import * as betgalaxy from './Well.styles.betgalaxy';
import * as betroyale from './Well.styles.betroyale';
import * as juicybet from './Well.styles.juicybet';
import * as goldenrush from './Well.styles.goldenrush';
import * as vikingbet from './Well.styles.vikingbet';
import * as questbet from './Well.styles.questbet';
import * as wellbet from './Well.styles.wellbet';
import * as sugarcastle from './Well.styles.sugarcastle';
import * as oldgill from './Well.styles.oldgill';
import * as buffalobet from './Well.styles.buffalobet';
import * as titanbet from './Well.styles.titanbet';
import * as gigabet from './Well.styles.gigabet';
import * as slambet from './Well.styles.slambet';
import * as betstride from './Well.styles.betstride';
import * as templebet from './Well.styles.templebet';
import * as goldenbet888 from './Well.styles.goldenbet888';
import * as hyperbet from './Well.styles.hyperbet';
import * as bet777 from './Well.styles.bet777';
import * as chromabet from './Well.styles.chromabet';
import * as bet575 from './Well.styles.bet575';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  sterlingparker,
  junglebet,
  volcanobet,
  puntgenie,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
};
